export enum PickingListTranshipmentStatus {
    Transhipmenting = 1,
    ConfirmedTranshipment = 2,
    // WaitingConfirm = 3,
    Reject = -1
}